import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import HttpClient from 'services/HttpClient';
import { getUserToken } from 'services/utils';
import { getBaseURL } from 'services/getBaseURL';
import convertToToman from 'services/toman';

const promissoryNoteURL = getBaseURL().wallet;
const http = new HttpClient();
// const guestToken = 'berear F373F0EF-63BF-4C95-B0E3-F62D8CE97A1E';

const initialState = {
	loanAmount: 0,
	noteAmount: 0,
	noteLoanAmountPercent: 0,
	saftePersonalInfoStep: 1,
	personalReview: [],
	promissoryNoteReview: [],
	payLink: '',
	promissoryNoteCost: 0,
	promissoryNoteData: {},
	promissoryNotePayment: {},
};

export const promissoryNoteAmount = createAsyncThunk('/promissoryNote/amount', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};

	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteAmount`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const promissoryNoteConfirm = createAsyncThunk('/promissoryNote/confirm', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteAmountConfirm`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const promissoryNoteDetails = createAsyncThunk('/promissoryNote/details', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};

	const response = await http
		.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteDetails`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const promissoryNoteDetailsConfirm = createAsyncThunk(
	'/promissoryNote/detailConfirm',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);
		const headers = {
			'Authorization': token,
		};
		const param = {
			CallBackUrl: params.callbackurl,
			walletRequestID: params.walletRequestID,
		};
		const response = await http
			.post(
				`${promissoryNoteURL}/WalletRequestPromissoryNoteDetailsConfirm`,
				param,
				{ headers: headers },
				params?.isToastfy,
			)
			.then((res) => res.data);
		return response;
	},
);
export const promissoryNotePaymentStatus = createAsyncThunk(
	'/promissoryNote/payment',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);
		const headers = {
			'Authorization': token,
			'Content-Type': 'application/json',
			'Content-Disposition': 'attachment',
		};
		const param = {
			walletRequestID: params.walletRequestID,
		};
		const response = await http
			.post(`${promissoryNoteURL}/WalletRequestPromissoryNotePaymentStatus`, param, {
				headers: headers,
			})
			.then((res) => res.data);
		return response;
	},
);
const promissoryNote = createSlice({
	name: 'promissoryNote',
	initialState,
	reducers: {
		setPersonalInfoStep(state, action) {
			state.saftePersonalInfoStep = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(promissoryNoteAmount.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(promissoryNoteAmount.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.loanAmount = Content.loanAmount;
					state.noteAmount = Content.PromissoryNoteAmount;
					state.noteLoanAmountPercent = Content.PromissoryNoteloanAmountPercent;
				}
				state.isLoading = false;
			})
			.addCase(promissoryNoteAmount.rejected, (state) => {
				state.isLoading = false;
			})

			.addCase(promissoryNoteDetails.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(promissoryNoteDetails.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.personalReview = [
						{
							id: 1,
							title: 'نام و نام خانوادگی:',
							subtitle: `${Content.Name} ${Content.LastName}`,
						},
						{
							id: 2,
							title: 'نام انگلیسی:',
							subtitle: Content.EnName,
						},
						{
							id: 3,
							title: 'نام خانوادگی انگلیسی:',
							subtitle: Content.EnLastName,
						},
						{
							id: 4,
							title: 'کدملی:',
							subtitle: Content.NationalCode,
						},
						{
							id: 5,
							title: 'کدپستی:',
							subtitle: Content.PostalCode,
						},
						{
							id: 6,
							title: 'شماره همراه:',
							subtitle: Content.Mobile,
						},
						{
							id: 7,
							title: 'آدرس:',
							subtitle: Content.Address,
						},
					];

					state.promissoryNoteReview = [
						{
							id: 8,
							title: 'مبلغ سفته:',
							subtitle: `${convertToToman(Content.PromissoryNoteAmount)} تومان`,
						},
						{
							id: 9,
							title: 'مبلغ سفته به حروف:',
							subtitle: Content.PromissoryNoteAmountInWords,
						},
						{
							id: 10,
							title: 'تاریخ صدور:',
							subtitle: Content.DateAdded,
						},
						{
							id: 11,
							title: 'تاریخ سررسید:',
							subtitle: Content.DueDate,
						},
						{
							id: 12,
							title: 'در وجه:',
							subtitle: Content.Payee,
						},
						{
							id: 13,
							title: 'بابت:',
							subtitle: Content.Description,
						},
						{
							id: 14,
							title: 'بانک عامل:',
							subtitle: Content.AgentBankName,
						},
					];
				}

				state.promissoryNoteCost = Content?.PromissoryNotesCost;
				state.isLoading = false;
			})
			.addCase(promissoryNoteDetails.rejected, (state) => {
				state.isLoading = false;
			})

			.addCase(promissoryNoteDetailsConfirm.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(promissoryNoteDetailsConfirm.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					window.location.href = Content.PaymentGatewayLink;
				}

				state.isLoading = false;
			})
			.addCase(promissoryNoteDetailsConfirm.rejected, (state) => {
				state.isLoading = false;
			})

			.addCase(promissoryNotePaymentStatus.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(promissoryNotePaymentStatus.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.promissoryNoteData = Content;
					state.promissoryNotePayment = Content;
				}
				state.isLoading = false;
			})
			.addCase(promissoryNotePaymentStatus.rejected, (state) => {
				state.isLoading = false;
			});
	},
});
export const { setPersonalInfoStep } = promissoryNote.actions;
export default promissoryNote.reducer;
